import React from "react"
import S from "./StyledContactSections"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhoneAlt, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import {
  faFacebook,
} from "@fortawesome/free-brands-svg-icons"

const ContactSections = () => {
  return (
    <S.ContactWrapper>
      <div className="line-section"></div>
      <S.ContactCompanySection>
        <div className="company-data">
          <h3>Dane firmowe</h3>
          <div className="description">
            <span>
              Siedziba naszej firmy znajduje się w miejsowości Recz,
              zachodniopomorskie
            </span>
            <span>NDA</span>
            <span>mgr inż. Dawid Mroczek</span>
            <span>ul. Tylna 6B/8, 73-210 Recz</span>
          </div>
        </div>
        {/* <div className="availability">
                    <h3>Jesteśmy do dyspozycji</h3>
                    <div className="open-hours-wrapper">
                        <span>Poniedziałek - Piątek</span>
                        <span>8:00 - 18:00</span>
                    </div>
                </div> */}
        <div className="contact-data">
          <h3>Dane kontaktowe</h3>
          <div className="description">
            <a href="tel:+48723902000" className="phone-number">
              <FontAwesomeIcon icon={faPhoneAlt} />
              723 90 2000
            </a>
            <a href="mailto:dawid.mroczek@nda-nazdor.pl">
              <FontAwesomeIcon icon={faEnvelope} />
              dawid.mroczek@nda-nazdor.pl
            </a>
          </div>
        </div>
      </S.ContactCompanySection>
      <div className="line-section"></div>
      <S.ContactSocialSection>
        <span className="title">Znajdziesz nas również Social Mediach</span>
        <div className="sm-wrapper">
          <ul>
            <li>
              <a
                className="icon facebook tooltip"
                href="#"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
                <span className="tooltip-text">Obserwuj nas na Facebooku</span>
              </a>
            </li>
            <li>
              <a
                className="icon instagram tooltip"
                href="#"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="instagram-img"></div>
                <span className="tooltip-text">
                  Obserwuj nas na Instagramie
                </span>
              </a>
            </li>
          </ul>
        </div>
      </S.ContactSocialSection>
    </S.ContactWrapper>
  )
}

export default ContactSections
